import React from "react";
import styled from "styled-components";

const ImgLoading = styled.img`
  position: absolute;
  left: 50%;
  top: 90%;
  /* margin: auto;  */
  height: 100px;
  width: 100px;
  max-width: 60px;
  max-height: 60px;
  z-index: 1005;
`;
class Loading extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    var imgSrc = document.querySelector("#imgLoading").src;
    document.querySelector("#imgLoading").src = imgSrc;
  }

  render() {
    return (
      <div style={{ overflow: "hidden" }}>
        <ImgLoading id="imgLoading" src={"/img/logo-startupitalia_2.gif"} />
      </div>
    );
  }
}

export default Loading;
